<template>

  <span
    :class="state.color"
    class="inline-flex text-white rounded-full h-6 px-3 justify-center items-center text-"
  >{{state.nome}}</span>

</template>

<script>
export default {
  props: ['state']
}
</script>

<style>
</style>
